import { useCallback, useEffect, useState } from 'react';
import type { AllCoursesDTO } from '../model/CourseDTO';
import fetchAuthenticatedFromBackend from '../api/fetchAuthenticatedFromBackend';
import { useAuth } from '../context/AuthContext';
import type { CategoryType } from '../features/intern/coursePage/edit/EditCoursePage';

export default function useInternCourses(type: CategoryType) {
  const [courses, setCourses] = useState<AllCoursesDTO | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<null | string>(null);
  const { logout } = useAuth();

  const path = `intern/v2/events/${type}`;

  const load = useCallback(() => {
    setLoading(true);
    fetchAuthenticatedFromBackend<AllCoursesDTO>(path)
      .then((r) => {
        setCourses(r);
      })
      .catch((err) => {
        if (err.response && err.response.status === 401) {
          logout();
        } else {
          setError(err);
        }
      })
      .finally(() => setLoading(false));
  }, [logout, path]);

  useEffect(() => load(), [load]);

  return { courses, loading, error, reload: load };
}
